import "core-js/modules/es.string.search";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/es.string.search";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.iterator";
/* global Weglot */

/**
 * Helper: Utils
 * ------------------------------------------------------------------------------
 * Frame utility functions.
 *
 * @namespace utils
 */

/**
 * Get unique objects from object literal.
 * @param {Object} object - Array/Object to remove duplicates from.
 * @returns {Object}
 */

export function unique(object) {
  return object.filter((value, index, self) => self.indexOf(value) === index);
}
/**
 * Get the difference of two arrays.
 * @param {Array} array - An array containing two arrays to diff.
 * @returns {Array}
 */

export function difference(array1, array2) {
  return array1.concat(array2).filter((value, index, self) => {
    return self.indexOf(value) === self.lastIndexOf(value);
  });
}
/**
 * Combine two objects using properties as the override.
 * @param {Object} defaults - Defaults options defined in script.
 * @param {Object} properties - Options defined by user.
 * @returns {Object} - Defaults modified options.
 */

export function extendDefaults(defaults, properties) {
  for (const property in properties) {
    if (properties != null && typeof properties !== 'undefined') {
      defaults[property] = properties[property];
    }
  }

  return defaults;
}
/**
 * Retrieves input data from a form.
 * @param {HTMLForm} form - HTML form elements.
 * @returns {Object} - Form data as an object literal.
 */

export function formToJSON(elements) {
  return [].reduce.call(elements, (data, element) => {
    if (element.name && element.value) {
      data[element.name] = element.value;
    }

    return data;
  }, {});
}
/**
 * Serialize all form data into a query string.
 * @param {Node} form - The form to serialize.
 * @returns {String}
 */

export function serialize(form) {
  const serialized = [];
  /**
   * Loop through each field in the form.
   */

  for (let i = 0; i < form.elements.length; i++) {
    const field = form.elements[i]; // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields

    if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') {
      continue;
    }
    /**
     * If a multi-select, get all selections.
     */


    if (field.type === 'select-multiple') {
      for (let counter = 0; counter < field.options.length; counter++) {
        if (!field.options[counter].selected) {
          continue;
        }

        serialized.push("".concat(encodeURIComponent(field.name), "=").concat(encodeURIComponent(field.options[counter].value)));
      }
    } else if (field.type !== 'checkbox' && field.type !== 'radio' || field.checked) {
      serialized.push("".concat(encodeURIComponent(field.name), "=").concat(encodeURIComponent(field.value)));
    }
  }

  return serialized.join('&');
}
/**
 * Shortcut function to add an event listener.
 * (c) 2017 Chris Ferdinandi, MIT License, https://gomakethings.com.
 * @param {String} event -The event type.
 * @param {Node} element - The element to attach the event to (optional, defaults to window).
 * @param {Function} callback - The callback to run on the event.
 * @param {Boolean} capture - If true, forces bubbling on non-bubbling events.
 */

export function on(event) {
  let element = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  let callback = arguments.length > 2 ? arguments[2] : undefined;
  let capture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  /**
   * If only a string is passed into the element parameter.
   */

  if (typeof elem === 'string') {
    document.querySelector(element).addEventListener(event, callback, capture);
    return;
  }
  /**
   * If an element is not defined in parameters, then shift callback across.
   */


  if (typeof element === 'function') {
    window.addEventListener(event, element);
    return;
  }
  /**
   * Default listener.
   */


  element.addEventListener(event, callback, capture);
}
/**
 * Remove an event listener.
 * (c) 2017 Chris Ferdinandi, MIT License, https://gomakethings.com.
 * @param {String} event - The event type.
 * @param {Node} element - The element to remove the event to (optional, defaults to window).
 * @param {Function} callback - The callback that ran on the event.
 * @param {Boolean} capture - If true, forces bubbling on non-bubbling events.
 */

export function off(event, element, callback) {
  let capture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  /**
   * If only a string is passed into the element parameter.
   */

  if (typeof element === 'string') {
    document.querySelector(element).removeEventListener(event, callback, capture);
    return;
  }
  /**
   * If an element is not defined in parameters, then shift callback across.
   */


  if (typeof element === 'function') {
    window.removeEventListener(event, element);
    return;
  }
  /**
   * Default listener.
   */


  element.removeEventListener(event, callback, capture);
}
/**
 * Get all siblings of an element.
 * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com.
 * @param {Node} element - The element you want get the siblings of.
 * @returns {Array}
 */

export function getSiblings(element) {
  return Array.prototype.filter.call(element.parentNode.children, sibling => {
    return sibling !== element;
  });
}
/**
 * Render function.
 * @param {String} template - The template string to render.
 * @param {Node} node - The node to render into.
 */

export function render(template, node) {
  if (!node) {
    return;
  }

  node.innerHTML = template;
}
/**
 * Browser detect and return a string.
 * - https://developer.mozilla.org/en-US/docs/Web/API/Window/navigator.
 * @returns {String}
 */

export function getBrowser() {
  const userAgent = window.navigator.userAgent; // The order matters here, and this may report false positives for unlisted browsers.

  if (userAgent.indexOf('Firefox') > -1) {
    // 'Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:61.0) Gecko/20100101 Firefox/61.0'
    return 'Firefox';
  } else if (userAgent.indexOf('Opera') > -1) {
    return 'Opera';
  } else if (userAgent.indexOf('Trident') > -1) {
    // 'Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; Zoom 3.6.0; wbx 1.0.0; rv:11.0) like Gecko'
    return 'Internet Explorer';
  } else if (userAgent.indexOf('Edge') > -1) {
    // 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 Edge/16.16299'
    return 'Edge';
  } else if (userAgent.indexOf('Chrome') > -1) {
    // 'Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Ubuntu Chromium/66.0.3359.181 Chrome/66.0.3359.181 Safari/537.36'
    return 'Chrome';
  } else if (userAgent.indexOf('Safari') > -1) {
    // 'Mozilla/5.0 (iPhone; CPU iPhone OS 11_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/11.0 Mobile/15E148 Safari/604.1 980x1306'
    return 'Safari';
  }

  return 'unknown';
}
/**
 * Get outerHTML of elements, taking care of SVG elements in IE as well.
 * @param {Element} element - Element to get outerHTML of.
 * @returns {String}
 */

export function getOuterHTML(element) {
  if (element.outerHTML) {
    return element.outerHTML;
  } else {
    const container = document.createElement('div');
    container.appendChild(element.cloneNode(true));
    return container.innerHTML;
  }
}
/**
 * Check if object is a HTMLElement.
 * @param {Object} element - HTML element to check.
 * @returns {HTMLElement}
 */

export function isElement(element) {
  return element instanceof window.Element || element instanceof window.HTMLDocument;
}
/**
 * Get URL query parameters as an object.
 * @returns {Object}
 */

export function getQueryParamsObject() {
  const result = {};
  const parser = document.createElement('a');
  parser.href = window.location.href;
  const query = parser.search.substring(1);
  const vars = query.split('&');

  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');
    result[pair[0]] = decodeURIComponent(pair[1]);
  }

  return result;
}
/**
 * Checks if an element is within viewport and visible boundary.
 * @param {HTMLElement} viewport - Viewport container.
 * @param {HTMLElement} element - Element to check.
 * @returns {Boolean}
 */

export function isElementInViewport(viewport, element) {
  const viewPortBounding = viewport.getBoundingClientRect();
  const elementBounding = element.getBoundingClientRect();
  const viewPortPosition = viewPortBounding.left + viewPortBounding.width;
  const elementPortPosition = elementBounding.left + elementBounding.width;

  const isElementBoundLeft = () => Math.ceil(elementBounding.left) >= viewPortBounding.left;

  const isElementBoundRight = () => viewPortPosition >= elementPortPosition;

  return isElementBoundLeft() && isElementBoundRight();
}
/**
 * Returns a function, that, as long as it continues to be invoked,
 * will not be triggered. The function will be called after it stops
 * being called for N milliseconds. If `immediate` is passed, trigger
 * the function on the leading edge, instead of the trailing.
 *
 * @param {Function} callback - The function to execute when timer is passed.
 * @param {Number} wait - The amount of time before debounce call is triggered.
 * @param {Boolean} immediate - Trigger the immediately.
 */

export function throttle(callback, wait) {
  let immediate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  let timeout = null;
  let initialCall = true;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    const callNow = immediate && initialCall;

    function next() {
      callback.apply(this, args);
      timeout = null;
    }

    if (callNow) {
      initialCall = false;
      next();
    }

    if (!timeout) {
      timeout = window.setTimeout(next, wait);
    }
  };
}
/**
 * Debounce functions for better performance
 * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param {Function} callback The function to debounce.
 * @param {Number} wait - The amount of time before debounce call is triggered.
 * @param {Boolean} immediate - Trigger the immediately.
 */

export function debounce(callback, wait, immediate) {
  let timeout = null;
  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    const later = function later() {
      timeout = null;

      if (!immediate) {
        callback.apply(this, args);
      }
    };

    const callNow = immediate && !timeout;
    window.clearTimeout(timeout);
    timeout = window.setTimeout(later, wait);

    if (callNow) {
      callback.apply(this, args);
    }
  };
}
/**
 * Update language used across all weglot selectors
*/

export function updateWeglotSelectorOption(weglotSelectors) {
  const currentLanguage = Weglot.getCurrentLang();
  let optionIndex = 0;

  if (weglotSelectors.length < 1) {
    return;
  }

  [...weglotSelectors[0].options].forEach((option, index) => {
    if (option.value !== currentLanguage) {
      return;
    }

    optionIndex = index;
  });
  weglotSelectors.forEach(selector => {
    selector.selectedIndex = optionIndex;
  });
}